import {
  AnnotationListItem,
  CreateAnnotationParams,
  CreateTemplateParams,
} from '.';
import { toMMSS } from '../utils/functions';
import { EXPRESS_API } from 'configs/api/expressApi';

const wrapAnnotationWithProps = (
  annotation: AnnotationListItem,
  options?: {
    isCompanyAnnotation: boolean;
  }
) => {
  annotation.startTimeText = toMMSS(annotation.startTime, 0);
  annotation.endTimeText = toMMSS(annotation.endTime, 0);

  annotation.isLinkEnabled = !!(
    (annotation.linkType === 'Web' && annotation.url) ||
    (annotation.linkType === 'Email' && annotation.email) ||
    (annotation.linkType === 'Phone' && annotation.phone)
  );

  if (!annotation.url) {
    annotation.url = '';
  }

  if (!annotation.email) {
    annotation.email = '';
  }

  if (!annotation.phone) {
    annotation.phone = '';
  }

  if (options) {
    const { isCompanyAnnotation } = options;
    if (isCompanyAnnotation) {
      annotation.type = 'image';
    }
  }

  return annotation;
};

export const getVideoAnnotations = async ({ videoId }: any) => {
  const response = await EXPRESS_API.get(`/videos/${videoId}/annotations`);

  const { videoAnnotations, companyAnnotations } = response.data;

  const formattedVideoAnnotations = videoAnnotations.map(
    (annotation: AnnotationListItem) => wrapAnnotationWithProps(annotation)
  );
  const formattedCompanyAnnotations = companyAnnotations.map(
    (annotation: AnnotationListItem) =>
      wrapAnnotationWithProps(annotation, { isCompanyAnnotation: true })
  );

  return {
    videoAnnotations: formattedVideoAnnotations,
    companyAnnotations: formattedCompanyAnnotations,
  };
};

export const createAnnotation = async ({
  videoId,
  data,
}: CreateAnnotationParams) => {
  const response = await EXPRESS_API.post(
    `/videos/${videoId}/annotations`,
    data
  );

  const annotation = response.data;

  const isCompanyAnnotation = !!data.customerId;
  if (isCompanyAnnotation) {
    return wrapAnnotationWithProps(annotation, { isCompanyAnnotation });
  }
  return wrapAnnotationWithProps(annotation);
};

export const updateAnnotation = async ({
  videoId,
  annotationId,
  data,
}: CreateAnnotationParams) => {
  const response = await EXPRESS_API.put(
    `/videos/${videoId}/annotations/${annotationId}`,
    data
  );

  const annotation = response.data;

  const isCompanyAnnotation = !!data.customerId;
  if (isCompanyAnnotation) {
    return wrapAnnotationWithProps(annotation, { isCompanyAnnotation });
  }
  return wrapAnnotationWithProps(annotation);
};

export const deleteAnnotation = async (
  videoId: string,
  annotationId: string,
  isCompanyAnnotation?: string
) => {
  await EXPRESS_API.delete(`/videos/${videoId}/annotations/${annotationId}`, {
    params: { isCompanyAnnotation },
  });

  return { annotationId };
};

export const getTemplates = async () => {
  const response = await EXPRESS_API.get('/annotation-templates');

  return response.data || [];
};

export const createTemplate = async ({ data }: CreateTemplateParams) => {
  const response = await EXPRESS_API.post('/annotation-templates', data);

  return response.data;
};

export const updateTemplate = async ({ data }: CreateTemplateParams) => {
  const response = await EXPRESS_API.put(
    `/annotation-templates/${data.templateId}`,
    data
  );

  return response.data;
};

export const deleteTemplate = async (templateId: string) => {
  await EXPRESS_API.delete(`/annotation-templates/${templateId}`);

  return { templateId };
};
